import {Button, ButtonGroup, closeDialog, Form, FormField, Label} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {singleLocationSchema} from '../utils/singleLocationSchema';
import {SimpleVectorsArray} from './SimpleVectorsArray';
import {SingleLocationFormValue} from './SingleLocationFormValue';

export interface SingleLocationFromMultipleLocationsProps {
  dialogId: string;
  isLoading: boolean;
  defaultValues?: SingleLocationFormValue;
  onFormSubmit: (formData: SingleLocationFormValue) => Promise<void>;
}

export function SingleLocationFromMultipleLocations(
  props: SingleLocationFromMultipleLocationsProps
) {
  const getDefaultValue = (): SingleLocationFormValue => {
    if (props.defaultValues) {
      return props.defaultValues;
    }

    return {
      storageLocation: [
        {
          isSelected: true,
          vectorType: 'AISLE',
          vectorPosition: 1,
          symbol: '',
        },
        {
          isSelected: true,
          vectorType: 'RACK',
          vectorPosition: 2,
          symbol: '',
        },
        {
          isSelected: true,
          vectorType: 'LEVEL',
          vectorPosition: 3,
          symbol: '',
        },
        {
          isSelected: true,
          vectorType: 'POSITION',
          vectorPosition: 4,
          symbol: '',
        },
        {
          isSelected: true,
          vectorType: 'OTHER',
          vectorPosition: 5,
          symbol: '',
        },
      ],
      note: '',
      allowMultipleUsage: false,
    };
  };

  return (
    <Form<SingleLocationFormValue>
      defaultValues={getDefaultValue()}
      onSubmit={props.onFormSubmit}
      experimentalZodSchema={singleLocationSchema}
      mode="onChange"
    >
      {(control, formApi) => (
        <VStack spacing={4}>
          <VStack spacing={1}>
            <HStack spacing={4}>
              <Box flex={1}>
                <Label tooltip={i18n.t('entity.tireWarehouses.labels.vector.tooltip')}>
                  {i18n.t('entity.tireWarehouses.labels.vector')}
                </Label>
              </Box>
              <Box flex={1}>
                <Label tooltip={i18n.t('entity.tireWarehouses.labels.symbol.tooltip')}>
                  {i18n.t('entity.tireWarehouses.labels.symbol')}
                </Label>
              </Box>
            </HStack>
            <SimpleVectorsArray control={control} formApi={formApi} isSelectVisible={false} />
          </VStack>
          <FormField
            type="textarea"
            name="note"
            control={control}
            label={i18n.t('general.labels.note')}
          />
          <FormField
            type="checkbox"
            name="allowMultipleUsage"
            control={control}
            label={i18n.t('entity.tireWarehouses.labels.unlimitedUsage')}
          />
          <ButtonGroup align="right">
            <Button
              title={i18n.t('general.actions.cancel')}
              variant="secondary"
              onClick={() => closeDialog(props.dialogId)}
              isDisabled={props.isLoading}
            />
            <Button
              title={i18n.t('general.actions.save')}
              variant="primary"
              type="submit"
              isLoading={props.isLoading}
            />
          </ButtonGroup>
        </VStack>
      )}
    </Form>
  );
}
